/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type WorkPackageStatus = typeof WorkPackageStatus[keyof typeof WorkPackageStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkPackageStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;
